import { Accordion } from '@mantine/core';
import cs from 'classnames';
import Image from 'next/image';
import type { FC } from 'react';
import { RoundAltArrowDown } from 'solar-icons';
import { FILE_BROWSER_URL } from '@/Module/Core/Constant';
import type { ISubscriptionPlan } from '@/Module/Subscription/Model/DataModel';
type IProps = Pick<ISubscriptionPlan, 'subscriptionDescription'>;
const SubscriptionDescriptionNew: FC<IProps> = ({
  subscriptionDescription
}) => {
  const items = subscriptionDescription?.split('\n') ?? [];
  return <div data-sentry-component="SubscriptionDescriptionNew" data-sentry-source-file="SubscriptionDescriptionNew.tsx">
      <Accordion chevronPosition="right" chevron={<RoundAltArrowDown />} classNames={{
      control: 'bg-grayOne rounded-md ',
      item: 'border-0',
      content: 'px-0 pt-4 pb-0',
      chevron: 'w-auto'
    }} data-sentry-element="Accordion" data-sentry-source-file="SubscriptionDescriptionNew.tsx">
        <Accordion.Item key="subscription" value="subscription" data-sentry-element="unknown" data-sentry-source-file="SubscriptionDescriptionNew.tsx">
          <Accordion.Control data-sentry-element="unknown" data-sentry-source-file="SubscriptionDescriptionNew.tsx">محتواهای اشتراک خریداری شده</Accordion.Control>
          <Accordion.Panel data-sentry-element="unknown" data-sentry-source-file="SubscriptionDescriptionNew.tsx">
            {' '}
            {items.map(item => <li className="mb-3 flex flex-row items-center rounded-md p-2 even:bg-grayOne" key={item}>
                {item.includes('-') ? <Image width={16} height={16} src={`${FILE_BROWSER_URL}/img/cancel.webp`} className={cs(`text-greenThree max-w-[16px] ml-1`)} alt="accept" /> : <Image width={16} height={16} src={`${FILE_BROWSER_URL}/img/accept.webp`} className={cs(`text-greenThree max-w-[16px] ml-1`)} alt="accept" />}
                <span className={cs(` text-sm text-blackFive`)}>{item.replace('-', '')}</span>
              </li>)}
          </Accordion.Panel>
        </Accordion.Item>
      </Accordion>
    </div>;
};
export default SubscriptionDescriptionNew;